import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api`;

const getAuthHeaders = () => {
  const token = sessionStorage.getItem('token');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
};

const dashboardService = {
  getBreakdownStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/dashboard/breakdown`, getAuthHeaders());
      return response.data;
    } catch (error) {
     
      throw error.response?.data || error;
    }
  },

  getPreventiveStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/dashboard/preventive`, getAuthHeaders());
      return response.data;
    } catch (error) {
  
      throw error.response?.data || error;
    }
  },

  getAssistantDashboard: async () => {
    try {
      const response = await axios.get(`${API_URL}/dashboard/assistant`, getAuthHeaders());
      return response.data;
    } catch (error) {

      throw error.response?.data || error;
    }
  }
};

export default dashboardService;
